import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { AdminUserPasswordForm } from 'components/Forms';
import { useStore } from 'hooks/useRootStore';
import { EndUserPasswordForm } from 'components/Forms/EndUserProfileForm';
import { SecondaryUserPasswordForm } from 'components/Forms/AdminUserProfileForm/SecondaryUserPassword';

export const AdminUserPassword: FC = observer(() => {
  const {
    userStore: { user /*, getProfile*/ },
  } = useStore();
  return (
    <>
      {user && (user.permission === 'SystemAdmin' || user.permission === 'BillingAdmin') ? (
        <SecondaryUserPasswordForm />
      ) : (
        ''
      )}
      {user && user.permission === 'ClientAdmin' ? <AdminUserPasswordForm /> : ''}
      {user && (user.permission === 'EndUser' || user.permission === 'Manager') ? <EndUserPasswordForm /> : ''}
    </>
  );
});
